import React, { useState } from 'react';
import { Check, ChevronDown, ChevronUp, ShieldCheck, Star, Lock, CheckCircle2 } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { SocialProofPopup } from '../components/SocialProofPopup';
const IMG_MAIN = 'https://cdn.magicpatterns.com/uploads/hfpHcGVsfXaZ5Z7tfMkPuz/mockup.png';
const IMG_HERO = 'https://cdn.magicpatterns.com/uploads/eFpk6mTSWQq1UxfUXP8KRv/ChatGPT_Image_Mar_13,_2026,_03_31_02_PM.png';
const IMG_BONUS_1 = 'https://cdn.magicpatterns.com/uploads/mCWp9fEvRztSSF2bNctyBU/BONUS1.png';
const IMG_BONUS_2 = 'https://cdn.magicpatterns.com/uploads/egPPX1uLuk9eWCY8dBiafW/BONUS2.png';
const IMG_BONUS_3 = 'https://cdn.magicpatterns.com/uploads/uwTjhJvWHpp5wR5E7zNNf3/BONUS3.png';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/45932163039420:1';
const TESTIMONIALS = [{
  name: 'Julián Mendez',
  age: '28 años',
  role: 'Emprendedor',
  text: 'Sentía que trabajaba todo el día pero no avanzaba. Con el sistema de 7 etapas logré ordenar mi semana y por fin lancé mi proyecto personal. No es magia, es orden puro.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Carla Ricci',
  age: '32 años',
  role: 'Diseñadora Freelance',
  text: 'La procrastinación me estaba comiendo viva. El método anti-procrastinación fue un antes y un después. Ahora tengo claridad mental y disfruto mi tiempo libre sin culpa.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  name: 'Mariana Torres',
  age: '35 años',
  role: 'Gerente de Ventas',
  text: 'Simple, directo y aplicable. Nada de relleno motivacional barato. Herramientas concretas que apliqué desde el día 1. Vale cada centavo.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}];
const FAQS = [{
  q: '¿Es solo teoría?',
  a: 'No. Cada etapa incluye aplicación práctica diseñada para generar cambios inmediatos en tu rutina y mentalidad.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. Está diseñado para empezar desde tu situación actual, sin importar tu nivel de conocimiento previo en desarrollo personal.'
}, {
  q: '¿Puedo hacerlo a mi ritmo?',
  a: 'Sí. El acceso es de por vida, por lo que podés avanzar a la velocidad que tu agenda permita.'
}, {
  q: '¿Es material digital?',
  a: 'Sí. Acceso y descarga inmediata a todo el sistema, guías y bonos apenas realizás la compra.'
}];
function scrollToOffer(e: React.MouseEvent) {
  e.preventDefault();
  const target = document.getElementById('compra');
  if (!target) return;
  const start = window.scrollY;
  const end = target.getBoundingClientRect().top + window.scrollY;
  const duration = 1500;
  const startTime = performance.now();
  function step(now: number) {
    const elapsed = now - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = progress < 0.5 ? 4 * progress ** 3 : 1 - (-2 * progress + 2) ** 3 / 2;
    window.scrollTo(0, start + (end - start) * ease);
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}
export function SalesPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  return <div className="font-sans min-h-screen" style={{
    backgroundColor: 'var(--color-cream)',
    color: 'var(--color-text)'
  }} data-id="element-20">
      <SocialProofPopup data-id="element-21" />

      {/* Urgency Bar */}
      <div className="py-2.5 sticky top-0 z-40 shadow-sm backdrop-blur-md" style={{
      backgroundColor: 'rgba(245, 237, 232, 0.95)',
      borderBottom: '1px solid var(--color-champagne)'
    }} data-id="element-22">
        <div className="container mx-auto px-4 flex justify-center items-center gap-4" data-id="element-23">
          <CountdownTimer data-id="element-24" />
          <span className="hidden md:inline text-xs tracking-widest uppercase font-medium" style={{
          color: 'var(--color-cafe)'
        }} data-id="element-25">
            Cupos Limitados
          </span>
        </div>
      </div>

      {/* Hero */}
      <header className="py-10 md:py-14 px-4" style={{
      background: 'linear-gradient(to bottom, var(--color-cream), var(--color-beige))'
    }} data-id="element-26">
        <div className="max-w-4xl mx-auto text-center" data-id="element-27">
          <div className="inline-block px-4 py-1.5 rounded-full text-xs tracking-widest uppercase mb-5" style={{
          backgroundColor: 'var(--color-rose-soft)',
          color: 'var(--color-text-light)',
          border: '1px solid var(--color-champagne)'
        }} data-id="element-28">
            Para personas que sienten que están hechas para más
          </div>

          <h1 className="text-4xl md:text-6xl font-heading mb-3 leading-tight" style={{
          color: 'var(--color-text)'
        }} data-id="element-29">
            El Sistema{' '}
            <span className="italic font-bold" style={{
            color: 'var(--color-cafe)'
          }} data-id="element-30">
              99%
            </span>
          </h1>

          <p className="text-lg md:text-xl mb-6 max-w-2xl mx-auto font-light" style={{
          color: 'var(--color-text)'
        }} data-id="element-31">
            El método de 7 etapas para{' '}
            <span className="font-medium italic" style={{
            color: 'var(--color-cafe)'
          }} data-id="element-32">
              dejar de procrastinar
            </span>{' '}
            y construir tu mejor versión en menos de 14 días.
          </p>

          <img src={IMG_HERO} alt="Sistema Salí del 99%" className="w-full max-w-lg mx-auto rounded-2xl shadow-xl mb-6" data-id="element-33" />

          <button onClick={scrollToOffer} className="inline-flex items-center justify-center text-lg md:text-xl font-bold py-4 px-10 rounded-full shadow-lg transition-all transform hover:-translate-y-1 w-full md:w-auto animate-pulse-slow" style={{
          backgroundColor: 'var(--color-blush)',
          color: 'var(--color-text)'
        }} data-id="element-34">
            Quiero Empezar Hoy
          </button>
          <div className="mt-3 flex justify-center items-center gap-2 text-xs" style={{
          color: 'var(--color-text-light)'
        }} data-id="element-35">
            <ShieldCheck className="w-3.5 h-3.5" style={{
            color: '#8BA888'
          }} data-id="element-36" />
            <span data-id="element-37">Garantía de 7 días · Pago seguro</span>
          </div>
        </div>
      </header>

      {/* Problem */}
      <section className="py-10 px-4" style={{
      backgroundColor: 'var(--color-cream)'
    }} data-id="element-38">
        <div className="max-w-3xl mx-auto" data-id="element-39">
          <h2 className="text-2xl md:text-3xl text-center mb-6 font-heading" style={{
          color: 'var(--color-text)'
        }} data-id="element-40">
            Si estás leyendo esto, probablemente te pasa algo así:
          </h2>

          <div className="p-5 md:p-6 rounded-2xl" style={{
          backgroundColor: 'var(--color-rose-soft)',
          borderLeft: '3px solid var(--color-champagne)'
        }} data-id="element-41">
            <p className="text-base mb-4 font-light" style={{
            color: 'var(--color-text)'
          }} data-id="element-42">
              Cumplís con tus responsabilidades en piloto automático. Trabajás.
              Estudiás. Respondés.{' '}
              <span className="font-medium" data-id="element-43">Pero internamente sentís que:</span>
            </p>
            <ul className="space-y-2 mb-4" data-id="element-44">
              {['No estás creciendo.', 'Estás usando solo una parte de tu potencial.', 'Postergás decisiones importantes.', 'Sabés lo que deberías hacer… pero no lo hacés.'].map((item, i) => <li key={i} className="flex items-center text-sm" data-id="element-45">
                  <div className="w-1.5 h-1.5 rounded-full mr-3 flex-shrink-0" style={{
                backgroundColor: 'var(--color-gold)'
              }} data-id="element-46"></div>
                  <span style={{
                color: 'var(--color-text)'
              }} data-id="element-47">
                    {item}
                  </span>
                </li>)}
            </ul>
            <p className="text-lg font-script text-center" style={{
            color: 'var(--color-cafe)'
          }} data-id="element-48">
              Y eso genera mucha frustración.
            </p>
          </div>

          <p className="text-center mt-5 text-base font-light" style={{
          color: 'var(--color-text)'
        }} data-id="element-49">
            No porque seas incapaz. Sino porque{' '}
            <span className="font-medium italic" style={{
            color: 'var(--color-cafe)'
          }} data-id="element-50">
              no tenés una estructura personal
            </span>{' '}
            que te guíe.
          </p>
        </div>
      </section>

      {/* Real Problem + Skills */}
      <section className="py-10 px-4" style={{
      backgroundColor: 'var(--color-beige)'
    }} data-id="element-51">
        <div className="max-w-3xl mx-auto" data-id="element-52">
          <h2 className="text-2xl md:text-3xl font-heading text-center mb-2" style={{
          color: 'var(--color-text)'
        }} data-id="element-53">
            El problema real
          </h2>
          <p className="text-center text-base mb-6 font-light" style={{
          color: 'var(--color-text-light)'
        }} data-id="element-54">
            La mayoría vive{' '}
            <span className="font-medium italic" style={{
            color: 'var(--color-cafe)'
          }} data-id="element-55">
              reaccionando
            </span>{' '}
            a obligaciones, urgencias y lo que otros esperan.
          </p>

          <div className="grid grid-cols-1 gap-2 mb-6" data-id="element-56">
            {['Diseñar su identidad de forma consciente', 'Construir disciplina emocional', 'Eliminar la procrastinación', 'Ordenar su mente', 'Crear un sistema semanal personal'].map((item, i) => <div key={i} className="flex items-center gap-3 rounded-xl px-4 py-2.5 bg-white shadow-sm border text-sm" style={{
            borderColor: 'rgba(232, 213, 196, 0.5)'
          }} data-id="element-57">
                <div className="w-1.5 h-1.5 rotate-45 flex-shrink-0" style={{
              backgroundColor: 'var(--color-blush)'
            }} data-id="element-58"></div>
                <span className="font-light" style={{
              color: 'var(--color-text)'
            }} data-id="element-59">
                  {item}
                </span>
              </div>)}
          </div>

          <div className="rounded-2xl p-5 text-center bg-white shadow-sm border" style={{
          borderColor: 'var(--color-champagne)'
        }} data-id="element-60">
            <p className="text-lg font-heading" style={{
            color: 'var(--color-text)'
          }} data-id="element-61">
              Sin estructura, dependés de la motivación.
            </p>
            <p className="text-xl font-script mt-1" style={{
            color: 'var(--color-cafe)'
          }} data-id="element-62">
              Y la motivación es inestable.
            </p>
          </div>
        </div>
      </section>

      {/* Solution + What's Included (merged) */}
      <section className="py-10 px-4" style={{
      backgroundColor: 'var(--color-cream)'
    }} data-id="element-63">
        <div className="max-w-4xl mx-auto" data-id="element-64">
          <div className="text-center mb-6" data-id="element-65">
            <p className="uppercase tracking-widest font-medium text-xs mb-2" style={{
            color: 'var(--color-text-light)'
          }} data-id="element-66">
              Es por eso que creamos
            </p>
            <h2 className="text-3xl md:text-5xl font-heading italic" style={{
            color: 'var(--color-cafe)'
          }} data-id="element-67">
              "Salí del 99%"
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center mb-8" data-id="element-68">
            <img src={IMG_MAIN} alt="Sistema Completo" className="w-full rounded-2xl shadow-lg" data-id="element-69" />
            <div data-id="element-70">
              <h3 className="text-xl font-heading mb-4" style={{
              color: 'var(--color-text)'
            }} data-id="element-71">
                Este sistema te guía para:
              </h3>
              <ul className="space-y-3 mb-5" data-id="element-72">
                {['Identificar los patrones que te frenan', 'Reordenar tu mentalidad', 'Construir disciplina real', 'Diseñar hábitos alineados', 'Crear dirección personal clara'].map((item, i) => <li key={i} className="flex items-center text-sm font-light" data-id="element-73">
                    <Check className="w-4 h-4 mr-3 flex-shrink-0" style={{
                  color: 'var(--color-gold)'
                }} data-id="element-74" />
                    <span style={{
                  color: 'var(--color-text)'
                }} data-id="element-75">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <h3 className="text-xl font-heading mb-3" style={{
              color: 'var(--color-text)'
            }} data-id="element-76">
                ¿Qué incluye?
              </h3>
              <ul className="space-y-2" data-id="element-77">
                {['7 Guías Digitales Progresivas', 'Ejercicios prácticos en cada etapa', 'Sistema semanal estructurado', 'Método anti-procrastinación', 'Plan de activación de 21 días'].map((item, i) => <li key={i} className="flex items-center text-sm font-light" data-id="element-78">
                    <Check className="w-4 h-4 mr-3 flex-shrink-0" style={{
                  color: 'var(--color-gold)'
                }} data-id="element-79" />
                    <span style={{
                  color: 'var(--color-text)'
                }} data-id="element-80">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center" data-id="element-81">
            <button onClick={scrollToOffer} className="inline-flex items-center justify-center text-lg font-bold py-4 px-10 rounded-full shadow-md transition-all w-full md:w-auto hover:-translate-y-1 transform" style={{
            backgroundColor: 'var(--color-blush)',
            color: 'var(--color-text)'
          }} data-id="element-82">
              Quiero Acceso Inmediato
            </button>
          </div>
        </div>
      </section>

      {/* 7 Days + Before/After (merged) */}
      <section className="py-10 px-4" style={{
      backgroundColor: 'var(--color-beige)'
    }} data-id="element-83">
        <div className="max-w-4xl mx-auto" data-id="element-84">
          <h2 className="text-2xl md:text-3xl font-heading text-center mb-5" style={{
          color: 'var(--color-text)'
        }} data-id="element-85">
            Lo que cambia en los primeros 7 días
          </h2>

          <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-86">
            {/* Checklist */}
            <div className="rounded-2xl p-5 shadow-sm border" style={{
            backgroundColor: 'var(--color-rose-soft)',
            borderColor: 'var(--color-champagne)'
          }} data-id="element-87">
              <ul className="space-y-3" data-id="element-88">
                {['Detectar qué te frena', 'Tomar decisiones postergadas', 'Estructura productiva semanal', 'Reducir distracciones', 'Sentir dirección'].map((item, i) => <li key={i} className="flex items-center gap-2 text-sm font-light" style={{
                color: 'var(--color-text)'
              }} data-id="element-89">
                    <Check className="w-3.5 h-3.5 flex-shrink-0" style={{
                  color: 'var(--color-gold)'
                }} data-id="element-90" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* Before */}
            <div className="bg-white p-5 rounded-2xl shadow-sm border relative" style={{
            borderColor: 'rgba(232, 213, 196, 0.5)'
          }} data-id="element-91">
              <div className="absolute top-0 left-0 w-full h-1.5 rounded-t-2xl" style={{
              backgroundColor: 'var(--color-rose-soft)'
            }} data-id="element-92"></div>
              <h3 className="text-lg font-heading mb-3 text-center" style={{
              color: 'var(--color-text-light)'
            }} data-id="element-93">
                Antes
              </h3>
              <ul className="space-y-2" data-id="element-94">
                {['Estancamiento', 'Procrastinación', 'Sin claridad', 'Comparación constante', 'Sin dirección'].map((item, i) => <li key={i} className="flex items-center text-sm font-light" style={{
                color: 'var(--color-text-light)'
              }} data-id="element-95">
                    <span className="w-1 h-1 rounded-full mr-3 flex-shrink-0 opacity-50" style={{
                  backgroundColor: 'var(--color-text-light)'
                }} data-id="element-96"></span>
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="bg-white p-5 rounded-2xl shadow-sm border relative" style={{
            borderColor: 'var(--color-champagne)'
          }} data-id="element-97">
              <div className="absolute top-0 left-0 w-full h-1.5 rounded-t-2xl" style={{
              backgroundColor: '#E2EBE0'
            }} data-id="element-98"></div>
              <h3 className="text-lg font-heading mb-3 text-center" style={{
              color: 'var(--color-text)'
            }} data-id="element-99">
                Después
              </h3>
              <ul className="space-y-2" data-id="element-100">
                {['Mayor conciencia', 'Decisiones firmes', 'Sistema semanal claro', 'Acción sostenida', 'Progreso real'].map((item, i) => <li key={i} className="flex items-center text-sm font-medium" style={{
                color: 'var(--color-text)'
              }} data-id="element-101">
                    <CheckCircle2 className="w-3.5 h-3.5 mr-3 flex-shrink-0" style={{
                  color: '#8BA888'
                }} data-id="element-102" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-10 px-4" style={{
      background: 'linear-gradient(to bottom, var(--color-cream), var(--color-rose-soft))'
    }} data-id="element-103">
        <div className="max-w-5xl mx-auto" data-id="element-104">
          <div className="text-center mb-6" data-id="element-105">
            <span className="inline-block px-3 py-1 rounded-full text-[10px] font-bold tracking-widest uppercase mb-3" style={{
            backgroundColor: 'var(--color-gold)',
            color: 'white'
          }} data-id="element-106">
              Gratis hoy
            </span>
            <h2 className="text-2xl md:text-3xl font-heading" style={{
            color: 'var(--color-text)'
          }} data-id="element-107">
              Bonos Exclusivos Incluidos
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-4" data-id="element-108">
            {[{
            img: IMG_BONUS_1,
            label: 'BONO #1',
            title: 'Plan 21 Días',
            desc: 'Acciones concretas para romper la inercia.'
          }, {
            img: IMG_BONUS_2,
            label: 'BONO #2',
            title: 'Plantilla de Identidad',
            desc: 'Definí quién estás construyendo.'
          }, {
            img: IMG_BONUS_3,
            label: 'BONO #3',
            title: 'Vision Board Estratégico',
            desc: 'Convertí deseos en metas claras.'
          }].map((bonus, i) => <button key={i} onClick={scrollToOffer} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all block w-full text-left border" style={{
            borderColor: 'rgba(232, 213, 196, 0.5)'
          }} data-id="element-109">
                <div className="relative" data-id="element-110">
                  <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full text-[10px] font-bold tracking-widest uppercase z-10" style={{
                backgroundColor: 'var(--color-gold)',
                color: 'white'
              }} data-id="element-111">
                    GRATIS
                  </span>
                  <div className="w-full overflow-hidden" style={{
                backgroundColor: 'var(--color-beige)'
              }} data-id="element-112">
                    <img src={bonus.img} alt={bonus.title} className="w-full h-auto object-contain" data-id="element-113" />
                  </div>
                </div>
                <div className="p-4" data-id="element-114">
                  <div className="text-[10px] tracking-widest uppercase mb-1 font-medium" style={{
                color: 'var(--color-cafe)'
              }} data-id="element-115">
                    {bonus.label}
                  </div>
                  <h3 className="text-sm font-heading mb-1" style={{
                color: 'var(--color-text)'
              }} data-id="element-116">
                    {bonus.title}
                  </h3>
                  <p className="text-xs font-light" style={{
                color: 'var(--color-text-light)'
              }} data-id="element-117">
                    {bonus.desc}
                  </p>
                </div>
              </button>)}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-10 px-4" style={{
      backgroundColor: 'var(--color-cream)'
    }} data-id="element-118">
        <div className="max-w-5xl mx-auto" data-id="element-119">
          <h2 className="text-2xl md:text-3xl font-heading text-center mb-6" style={{
          color: 'var(--color-text)'
        }} data-id="element-120">
            Lo que dicen quienes ya lo aplican
          </h2>

          <div className="grid md:grid-cols-3 gap-4" data-id="element-121">
            {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-5 rounded-2xl shadow-sm border flex flex-col" style={{
            borderColor: 'var(--color-champagne)'
          }} data-id="element-122">
                <div className="flex items-center mb-3" data-id="element-123">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3 h-3 fill-current mr-0.5" style={{
                color: 'var(--color-gold)'
              }} data-id="element-124" />)}
                </div>
                <p className="font-light italic text-xs mb-4 flex-grow leading-relaxed" style={{
              color: 'var(--color-text)'
            }} data-id="element-125">
                  "{t.text}"
                </p>
                <div className="flex items-center pt-3 border-t" style={{
              borderColor: 'rgba(232, 213, 196, 0.4)'
            }} data-id="element-126">
                  <img src={t.image} alt={t.name} className="w-8 h-8 rounded-full object-cover mr-3" data-id="element-127" />
                  <div data-id="element-128">
                    <p className="font-medium text-xs" style={{
                  color: 'var(--color-text)'
                }} data-id="element-129">
                      {t.name}
                    </p>
                    <p className="text-[10px] font-light" style={{
                  color: 'var(--color-text-light)'
                }} data-id="element-130">
                      {t.role}, {t.age}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pricing + Guarantee (merged) */}
      <section id="compra" className="py-10 px-4" style={{
      background: 'linear-gradient(to bottom, var(--color-cream), var(--color-blush))'
    }} data-id="element-131">
        <div className="max-w-2xl mx-auto" data-id="element-132">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border" style={{
          borderColor: 'var(--color-champagne)'
        }} data-id="element-133">
            <div className="py-3 text-center" style={{
            backgroundColor: 'var(--color-rose-soft)'
          }} data-id="element-134">
              <h3 className="text-base font-heading tracking-wide" style={{
              color: 'var(--color-text)'
            }} data-id="element-135">
                OFERTA ESPECIAL POR TIEMPO LIMITADO
              </h3>
            </div>

            <div className="p-6 md:p-8" data-id="element-136">
              <h2 className="text-2xl font-heading text-center mb-6" style={{
              color: 'var(--color-cafe)'
            }} data-id="element-137">
                Hoy Recibís
              </h2>

              <div className="space-y-3 mb-6" data-id="element-138">
                {[{
                label: 'Sistema completo SALÍ DEL 99% (7 etapas)',
                value: 'INCLUIDO'
              }, {
                label: 'Plan 21 Días (Bono)',
                value: 'GRATIS'
              }, {
                label: 'Journaling (Bono)',
                value: 'GRATIS'
              }, {
                label: 'Vision Board Estratégico (Bono)',
                value: 'GRATIS'
              }, {
                label: 'Acceso de por vida',
                value: 'INCLUIDO'
              }].map((row, i) => <div key={i} className="flex items-center justify-between border-b pb-2 text-sm" style={{
                borderColor: 'rgba(232, 213, 196, 0.4)'
              }} data-id="element-139">
                    <span className="font-light flex items-center" style={{
                  color: 'var(--color-text)'
                }} data-id="element-140">
                      <Check className="w-3.5 h-3.5 mr-2 flex-shrink-0" style={{
                    color: 'var(--color-gold)'
                  }} data-id="element-141" />
                      {row.label}
                    </span>
                    <span className="font-medium ml-3 tracking-wider text-xs" style={{
                  color: 'var(--color-cafe)'
                }} data-id="element-142">
                      {row.value}
                    </span>
                  </div>)}
              </div>

              <div className="text-center mb-6" data-id="element-143">
                <p className="text-sm mb-1 line-through font-light" style={{
                color: 'var(--color-text-light)'
              }} data-id="element-144">
                  Precio regular: ARS $79.990
                </p>
                <p className="text-5xl font-heading mb-2" style={{
                color: 'var(--color-text)'
              }} data-id="element-145">
                  ARS $19.990
                </p>
                <p className="text-[10px] font-medium uppercase tracking-widest" style={{
                color: 'var(--color-text-light)'
              }} data-id="element-146">
                  Pago único • Acceso inmediato
                </p>
              </div>

              <a href={CHECKOUT_URL} className="block w-full text-center text-xl font-bold py-5 rounded-full shadow-lg transition-all transform hover:-translate-y-1 animate-pulse-slow mb-4" style={{
              backgroundColor: 'var(--color-blush)',
              color: 'var(--color-text)'
            }} data-id="element-147">
                Acceder Ahora
              </a>

              <div className="flex justify-center items-center gap-4 text-[10px] font-light uppercase tracking-widest mb-6" style={{
              color: 'var(--color-text-light)'
            }} data-id="element-148">
                <div className="flex items-center" data-id="element-149">
                  <Lock className="w-3 h-3 mr-1" data-id="element-150" /> Pago Seguro
                </div>
                <div className="flex items-center" data-id="element-151">
                  <CheckCircle2 className="w-3 h-3 mr-1" data-id="element-152" /> Entrega Inmediata
                </div>
              </div>

              {/* Guarantee inline */}
              <div className="border-t pt-5 text-center" style={{
              borderColor: 'rgba(232, 213, 196, 0.4)'
            }} data-id="element-153">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-154">
                  <ShieldCheck className="w-6 h-6" style={{
                  color: '#8BA888'
                }} data-id="element-155" />
                  <span className="font-heading text-base" style={{
                  color: 'var(--color-text)'
                }} data-id="element-156">
                    Garantía de 7 días sin riesgo
                  </span>
                </div>
                <p className="text-xs font-light" style={{
                color: 'var(--color-text-light)'
              }} data-id="element-157">
                  Si no te aporta claridad y estructura, te devolvemos el 100%.
                  Sin preguntas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-8 px-4" style={{
      backgroundColor: 'var(--color-cream)'
    }} data-id="element-158">
        <div className="max-w-2xl mx-auto" data-id="element-159">
          <h2 className="text-2xl font-heading text-center mb-5" style={{
          color: 'var(--color-text)'
        }} data-id="element-160">
            Preguntas frecuentes
          </h2>
          <div className="space-y-2" data-id="element-161">
            {FAQS.map((faq, i) => <div key={i} className="rounded-xl shadow-sm overflow-hidden border" style={{
            borderColor: openFaq === i ? 'var(--color-blush)' : 'var(--color-champagne)'
          }} data-id="element-162">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full text-left p-4 flex items-center justify-between bg-white" data-id="element-163">
                  <h3 className="text-sm font-heading pr-4" style={{
                color: 'var(--color-text)'
              }} data-id="element-164">
                    {faq.q}
                  </h3>
                  {openFaq === i ? <ChevronUp className="w-4 h-4 flex-shrink-0" style={{
                color: 'var(--color-gold)'
              }} data-id="element-165" /> : <ChevronDown className="w-4 h-4 flex-shrink-0" style={{
                color: 'var(--color-gold)'
              }} data-id="element-166" />}
                </button>
                {openFaq === i && <div className="px-4 pb-4 text-xs font-light leading-relaxed border-t pt-3" style={{
              borderColor: 'rgba(232, 213, 196, 0.4)',
              color: 'var(--color-text-light)'
            }} data-id="element-167">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 text-center" style={{
      backgroundColor: 'var(--color-beige)'
    }} data-id="element-168">
        <div className="max-w-2xl mx-auto" data-id="element-169">
          <p className="text-base font-light mb-4" style={{
          color: 'var(--color-text)'
        }} data-id="element-170">
            Tu vida no se cambia con motivación.{' '}
            <span className="font-script text-2xl" style={{
            color: 'var(--color-cafe)'
          }} data-id="element-171">
              Se cambia con sistema.
            </span>
          </p>
          <button onClick={scrollToOffer} className="inline-flex items-center justify-center text-base font-bold py-3 px-8 rounded-full shadow-md transition-all hover:-translate-y-1 transform mb-4" style={{
          backgroundColor: 'var(--color-blush)',
          color: 'var(--color-text)'
        }} data-id="element-172">
            Empezar Hoy
          </button>
          <p className="text-[10px] font-light uppercase tracking-widest" style={{
          color: 'var(--color-text-light)'
        }} data-id="element-173">
            © 2024 Salí del 99%. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}